<template>
	<div>
		<k-modal
			id="dataTableComponent"
			:title="$t('modals.titles.requirementResponse')"
			size="xl"
			:okTitle="okBtnText"
			:cancelTitle="cancelBtnText"
			:customClass="modalClass"
			:okVariant="okVariant"
			:okDisabled="!validateOk"
			:cancelVariant="cancelVariant"
			@ok="okEvent"
			@beforeHide="closeModal"
		>
			<template v-slot:content>
				<b-row class="details mt-2">
					<div class="basicInformations">
						<label>{{ $t("commons.requirementName") }}</label> {{ requirement.description }}
					</div>
					<div class="basicInformations">
						<label>{{ $t("commons.requirementType") }}</label> {{ requirementType }}
					</div>
					<div class="textModal">
						<label
							><strong>{{ $t("commons.explanation") }}</strong></label
						>
						<div class="formatted-text-display">
							{{ requirement.explanation }}
						</div>
					</div>
				</b-row>
				<hr />

				<div class="table-responsive">
					<table id="data-table" style="overflow-x: auto; width: 100%">
						<thead>
							<tr>
								<th>{{ $t("commons.actions") }}</th>
								<th v-if="modalType != $requirementResponseModalType.anyView" style="width: 20px">Status</th>
								<th v-for="question in filteredQuestionsData" :key="question.idQuestion">
									{{ question.title }}
								</th>
							</tr>
						</thead>
						<tbody v-if="maxAnswers > 0">
							<tr v-for="n in maxAnswers" :key="n">
								<td class="text-center">
									<b-button
										v-if="shouldDisplayDeleteOrEditAction(n - 1)"
										:disabled="
											(n.formType == $FormType.ValidationForm &&
												modalType != $requirementResponseModalType.clientValidation) ||
											(n.formType == $FormType.FillerForm &&
												modalType != $requirementResponseModalType.requirementResponse)
										"
										class="edit-button"
										size="md"
										variant="link"
										@click="editAnswer(n - 1)"
									>
										<b-icon
											v-if="modalType == $requirementResponseModalType.requirementResponse"
											icon="pencil"
										></b-icon>
										<b-icon
											v-else-if="modalType == $requirementResponseModalType.clientValidation"
											icon="file-earmark-check"
										></b-icon>
									</b-button>
									<b-button
										v-if="shouldDisplayDeleteOrEditAction(n - 1)"
										:disabled="modalType != $requirementResponseModalType.requirementResponse"
										class="remove-button"
										size="md"
										variant="link"
										@click="deleteAnswer(n - 1)"
									>
										<b-icon icon="trash"></b-icon>
									</b-button>
									<b-button class="view-button" size="md" variant="link" @click="viewAnswer(n - 1)">
										<b-icon icon="eye"></b-icon>
									</b-button>
									<b-button
										v-show="hasAttachmentsForIndex(n - 1)"
										class="download-button"
										variant="link"
										size="md"
										@click="handleDownloadFiles(n - 1)"
									>
										<b-icon icon="download" scale="1" v-b-tooltip:[`hover.hover`]="downloadHoverObject" />
									</b-button>
								</td>
								<td v-if="modalType != $requirementResponseModalType.anyView" class="text-center">
									<b-badge :variant="getBadgeStatus(n - 1).variant" class="badge-lg">
										{{ getBadgeStatus(n - 1).text }}
									</b-badge>
								</td>
								<td
									class="question-cells"
									v-for="question in filteredQuestionsData"
									:key="question.idQuestion"
									:ref="'cell-' + n + '-' + question.idQuestion"
									:title="
										isTruncated('cell-' + n + '-' + question.idQuestion) ? getAnswerDescription(question, n - 1) : ''
									"
								>
									{{ getAnswerDescription(question, n - 1) }}
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div v-if="modalType == $requirementResponseModalType.requirementResponse" class="mb-2">
					<b-button class="btn-info" @click="openNew">
						{{ $t("modals.responseRequirement.addResponse") }}
					</b-button>
					<div v-if="showUserConfirmCheckbox" class="mt-3">
						<b-form-checkbox
							v-model="userConfirm"
							:disabled="modalType !== $requirementResponseModalType.requirementResponse"
							:title="$t('commons.userConfirm')"
						>
							{{ $t("commons.userConfirm") || "Estou ciente das informações deste requisito" }}
						</b-form-checkbox>
					</div>
				</div>
				<k-crud
					ref="tableRequirementResponseCRUD"
					:fields="requirementResponseCrudStructure"
					:data="requirementResponseData"
				/>
			</template>
			<template v-slot:footer="{}">
				<b-button
					:disabled="!validateReevaluate"
					variant="outline-info"
					v-if="modalType == $requirementResponseModalType.clientValidation"
					@click="reevaluateEvent"
					>{{ $t("buttons.reevaluate") }}</b-button
				>
				<b-button :variant="cancelVariant" @click="cancelEvent">{{ cancelBtnText }}</b-button>
				<b-button v-if="shouldShowSaveBtn" variant="info" @click="savePartialAnswers" :disabled="!validatePartial">{{
					$t("buttons.save")
				}}</b-button>
				<b-button :variant="okVariant" @click="okEvent" :disabled="!validateOk">{{ okBtnText }}</b-button>
			</template>
		</k-modal>
	</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import KModal from "../modals/KModal.vue";
import KCrud from "./KCrud.vue";
import ModalMixin from "../../mixins/ModalMixin";
import ValidityMixin from "@/mixins/ValidityMixin";

export default {
	components: { KModal, KCrud },
	mixins: [ModalMixin, ValidityMixin],
	data() {
		return {
			idInvite: 0,
			idRequirement: 0,
			reprocess: false,
			idStep: 0,
			idClient: 0,
			modalType: this.$requirementResponseModalType.anyView,
			questionsData: [],
			requirementResponseData: {
				issueDate: null,
				validityDate: null,
				answer: null,
				identifier: null,
				userConfirm: null,
				attach: [],
				scoreValue: 0,
				observation: null,
				description: null
			},
			isFillerValidatorOnReevaluation: false,
			isValidateActor: false,
			messageAction: this.$t("modals.responseRequirement.cancelInviteRejectReason"),
			modalCancelConfirmConfigs: {
				message: this.$t("modals.responseRequirement.modals.cancelConfirm.message"),
				title: this.$t("modals.responseRequirement.modals.cancelConfirm.title"),
				okTitle: this.$t("buttons.reject"),
				cancelTitle: this.$t("buttons.cancel")
			},
			modalPartialAnswerConfirm: {
				message: this.$t("modals.responseRequirement.modals.partialAnswerConfirm.message"),
				title: this.$t("modals.responseRequirement.modals.partialAnswerConfirm.title"),
				okTitle: this.$t("buttons.yes"),
				cancelTitle: this.$t("buttons.no"),
				primary: true
			},
			viewModalData: [],
			supplierHasCodeERP: false,
			mappedQuestionsWithConditions: [],
			requirementQuestionData: [],
			shouldShowConfirmModal: true,
			downloadHoverObject: {
				title: this.$t("commons.hovers.downloadFiles"),
				customClass: "custom-tooltip",
				interactive: false,
				placement: "bottom"
			},
			fileName: [],
			deletedFilesId: [],
			addedFile: false,
			userConfirm: false
		};
	},
	computed: {
		...mapGetters(["requirementResponse", "requirementWithInactivatedQuestions", "actualUser", "configurations"]),
		maxAnswers() {
			return Math.max(
				...this.questionsData.map((q) =>
					q.answers.some((answer) => answer != null) && q.answers ? q.answers.length : 0
				)
			);
		},
		filteredQuestionsData() {
			return this.questionsData.filter(
				(question) =>
					!(
						question.formType == this.$FormType.ValidationForm &&
						this.modalType != this.$requirementResponseModalType.clientValidation
					) ||
					(question.formType == this.$FormType.ValidationForm &&
						this.modalType == this.$requirementResponseModalType.anyView)
			);
		},
		shouldShowButton() {
			return (
				(this.questionsData.some(({ formType }) => formType === this.$FormType.ValidationForm) &&
					this.modalType === this.$requirementResponseModalType.clientValidation) ||
				this.modalType === this.$requirementResponseModalType.requirementResponse
			);
		},
		requirementName() {
			return this.requirement.description ? this.requirement.description : "";
		},
		modalClass() {
			if (this.modalType == this.$requirementResponseModalType.anyView) {
				return "hideButtons";
			}
			return null;
		},
		okBtnText() {
			switch (this.modalType) {
				case this.$requirementResponseModalType.requirementResponse:
					return this.$t("buttons.save");
				case this.$requirementResponseModalType.clientValidation:
				case this.$requirementResponseModalType.reprocess:
					return this.$t("buttons.approve");
			}
			return "";
		},
		cancelBtnText() {
			if (this.modalType == this.$requirementResponseModalType.requirementResponse) {
				return this.$t("buttons.cancel");
			}
			return this.$t("buttons.reject");
		},
		okVariant: function () {
			switch (this.modalType) {
				case this.$requirementResponseModalType.requirementResponse:
					return "info";
				case this.$requirementResponseModalType.clientValidation:
				case this.$requirementResponseModalType.reprocess:
				case this.$requirementResponseModalType.anyView:
					return "primary";
			}
			return "info";
		},
		cancelVariant: function () {
			switch (this.modalType) {
				case this.$requirementResponseModalType.requirementResponse:
					return "outline-info";
				case this.$requirementResponseModalType.clientValidation:
				case this.$requirementResponseModalType.reprocess:
				case this.$requirementResponseModalType.anyView:
					return "secondary";
			}
			return "outline-info";
		},
		requirementType: function () {
			let type = "";
			if (this.requirement.requirementType) {
				type = this.$t("commons.mandatory");
			} else {
				type = this.$t("commons.notMandatory");
			}
			return type;
		},
		requirement() {
			return this.requirementWithInactivatedQuestions;
		},
		requirementResponseCrudStructure() {
			let requirementResponseCrudStructure = [];

			if (this.modalType === this.$requirementResponseModalType.clientValidation && this.configurations?.AllowScore) {
				this.$setMinMax(0, 10);
				requirementResponseCrudStructure.push({
					rowNum: 0,
					width: "12",
					label: this.$t("modals.responseRequirement.inputScoreZeroToTen"),
					name: "scoreValue",
					type: "number",
					min: 0,
					max: 10,
					validation: this.$validations.number,
					isActive: () => {
						return this.modalType !== this.$requirementResponseModalType.anyView;
					}
				});
			}

			const isObservationVisible =
				this.modalType === this.$requirementResponseModalType.clientValidation ||
				!!this.requirementResponseData?.observation?.trim();

			requirementResponseCrudStructure.push({
				rowNum: 1,
				width: "12",
				label: this.$t("commons.observation"),
				name: "observation",
				placeholder: this.$t("commons.observation"),
				type: "textArea",
				isVisible: isObservationVisible,
				isActive: () => {
					return this.modalType == this.$requirementResponseModalType.clientValidation;
				}
			});

			const allowedModalTypes = [
				this.$requirementResponseModalType.anyView,
				this.$requirementResponseModalType.clientValidation
			];
			const isModalTypeAllowed = allowedModalTypes.includes(this.modalType);

			if (isModalTypeAllowed && this.requirement.validityType == this.$ValidityType.Date) {
				requirementResponseCrudStructure.push({
					rowNum: 2,
					width: "12",
					name: "validityDate",
					label: this.$t("commons.validityDate"),
					placeholder: this.$t("commons.placeholders.dayMonthYear"),
					type: "text",
					mask: "##/##/####",
					validation: this.$validations.dateValidateNotRequired,
					valueText: this.requirementResponse.validityDate,
					isActive: () => {
						return this.modalType !== this.$requirementResponseModalType.anyView;
					}
				});
			}

			return requirementResponseCrudStructure;
		},
		validateOk() {
			if (
				this.modalType == this.$requirementResponseModalType.clientValidation ||
				this.modalType == this.$requirementResponseModalType.reprocess
			) {
				if (!this.isScoreValid(this.requirementResponseData, this.configurations)) {
					return false;
				}

				if (!this.isValidityTypeDateValid(this.requirement, this.requirementResponseData)) {
					return false;
				}

				const hasUnreadyAnswer = this.questionsData
					.filter(({ formType }) => formType === this.$FormType.ValidationForm)
					.some(
						({ answers }) =>
							Array.isArray(answers) && answers.some(({ ready }) => ready !== this.$ResponseIndexReady.VallidFormReady)
					);

				if (!this.validateCrudFields(this.requirementResponseCrudStructure, this.requirementResponseData)) {
					return false;
				}

				return !hasUnreadyAnswer;
			}

			if (this.maxAnswers === 0 && this.requirement.requirementType) {
				return false;
			}
			if (this.requirement.userConfirm && !this.userConfirm) {
				return false;
			}

			return true;
		},
		validateReevaluate() {
			if (!this.requirementResponseData?.observation?.trim()) {
				return false;
			}
			return true;
		},
		validatePartial() {
			if (
				!this.isScoreValid(this.requirementResponseData, this.configurations) ||
				!this.validateCrudFields(this.requirementResponseCrudStructure, this.requirementResponseData)
			) {
				return false;
			}
			return true;
		},
		shouldShowSaveBtn() {
			return (
				this.configurations.PartialSaving &&
				this.modalType == this.$requirementResponseModalType.clientValidation &&
				this.questionsData.some((q) => q.formType === this.$FormType.ValidationForm)
			);
		},
		hasAnyAttachment() {
			return this.questionsData.some(
				(q) => q.answers && q.answers.some((a) => (Array.isArray(a.attaches) ? a.attaches.length > 0 : a.hasAnyAttach))
			);
		},
		showUserConfirmCheckbox() {
			return this.requirement.userConfirm;
		}
	},
	methods: {
		...mapActions([
			"getRequirementResponse",
			"getRequirementWithInactivatedQuestions",
			"updateRequirementResponseWorkflow",
			"createOrUpdateRequirementResponse",
			"cancelInvite",
			"getRequirementAttaches",
			"uploadFileRequirementResponse",
			"downloadRequirementResponseIndexDocument",
			"getConfigurationByClient"
		]),
		getBadgeStatus(n) {
			const { ready } = this.questionsData.flatMap((q) => q.answers).find((a) => a.responseIndex === n);

			switch (ready) {
				case this.$ResponseIndexReady.FilledFormReady:
					return { text: this.$t("modals.dataTable.filledStatus"), variant: "info" };
				case this.$ResponseIndexReady.VallidFormReady:
					return { text: this.$t("modals.dataTable.validatedStatus"), variant: "success" };
				case this.$ResponseIndexReady.NotReady:
					return { text: this.$t("modals.dataTable.partialStatus"), variant: "warning" };
				default:
					return { text: this.$t("modals.dataTable.unkown"), variant: "primary" };
			}
		},
		async setContextRequirement(contextRequirement) {
			this.modalType = contextRequirement.modalType;
			this.idInvite = contextRequirement.idInvite;
			this.idRequirement = contextRequirement.idRequirement;
			this.reprocess = contextRequirement.reprocess;
			this.idStep = contextRequirement.idStep;
			this.idClient = contextRequirement.idClient ?? this.actualUser.idClient;
			this.isFillerValidatorOnReevaluation = contextRequirement.isFillerValidatorOnReevaluation;
			this.isValidateActor = contextRequirement.isValidateActor;
			this.displayType = contextRequirement.displayType;
			this.supplierHasCodeERP = contextRequirement.supplierHasCodeERP;

			const input = { idInvite: contextRequirement.idInvite, idRequirement: contextRequirement.idRequirement };
			await this.getRequirementWithInactivatedQuestions(input);

			const configurationObj = {
				idClient: this.idClient,
				configurationNameList: ["PartialSaving", "AllowScore"]
			};
			await this.getConfigurationByClient(configurationObj);

			this.questionsData = this.requirementWithInactivatedQuestions.questions
				.filter((q) => q.isActive)
				.map((q) => ({ ...q, answers: [] }))
				.sort((a, b) => a.formType - b.formType);
			await this.getRequirementResponse(input);
			this.setRequirementResponse(input);
		},
		setRequirementResponse() {
			Object.assign(this.requirementResponseData, {
				issueDate: null,
				validityDate: null,
				userConfirm: null,
				observation: null,
				scoreValue: 0
			});

			if (!this.requirementResponse) return;

			const { status, issueDate, userConfirm, observation, validityDate, scoreValue } = this.requirementResponse;
			this.userConfirm = userConfirm || false;

			this.$set(this.requirementResponseData, "status", status);
			this.$set(this.requirementResponseData, "issueDate", issueDate);
			this.$set(this.requirementResponseData, "observation", observation);
			this.$set(this.requirementResponseData, "userConfirm", userConfirm);
			this.$set(this.requirementResponseData, "scoreValue", scoreValue);
			this.$set(this.requirementResponseData, "validityDate", this.mapRequirementDate(validityDate));

			if (!this.requirementResponse.answers) return;

			this.questionsData.forEach((question, index) => {
				const questionAnswers = this.requirementResponse.answers.filter(
					(answer) => answer.idQuestion === question.idQuestion
				);

				if (question.formType === this.$FormType.ValidationForm && !questionAnswers.length) {
					for (let index = 0; index < this.maxAnswers; index++) {
						questionAnswers.push({
							idAnswer: null,
							idQuestion: question.idQuestion,
							responseType: question.responseType,
							answer: null,
							description: null,
							justification: null,
							responseIndex: index,
							isInMemory: true,
							ready: this.$ResponseIndexReady.NotReady
						});
					}
				}

				questionAnswers.forEach((qa) => {
					const answer = {
						idAnswer: qa.idAnswer,
						idQuestion: qa.idQuestion,
						responseType: qa.responseType,
						answer: qa.answer,
						description: qa.description,
						justification: qa.justification,
						responseIndex: qa.responseIndex,
						isInMemory: qa.isInMemory,
						canEditAnswer: qa.canEditAnswer,
						hasAnyAttach: qa.hasAnyAttach,
						ready: qa.ready
					};

					this.questionsData[index].answers.push(answer);
				});
			});
		},
		mapRequirementDate(date) {
			if (!date) return null;
			let mappedDate = `${date.substring(8, 10)}/${date.substring(5, 7)}/${date.substring(0, 4)}`;
			return mappedDate;
		},
		async openNew() {
			const contextRequirement = this.createContextRequirementObject();
			await this.$parent.$refs.ResponseRequirementModal.setContextRequirement(contextRequirement);
			this.$bvModal.show("responseRequirementModal");
		},
		async editAnswer(index) {
			const answers = this.questionsData.flatMap((data) => data.answers).filter((a) => a.responseIndex == index);
			const contextRequirement = this.createContextRequirementObject(answers, index);
			await this.$parent.$refs.ResponseRequirementModal.setContextRequirement(contextRequirement);
			this.$bvModal.show("responseRequirementModal");
		},
		createContextRequirementObject(answers = [], index = this.maxAnswers, toView = false) {
			const parameters = {
				idRequirement: this.idRequirement,
				idInvite: this.idInvite,
				modalType: toView ? this.$requirementResponseModalType.anyView : this.modalType,
				reprocess: this.reprocess,
				idStep: this.idStep,
				idClient: this.idClient,
				isFillerValidatorOnReevaluation: this.isFillerValidatorOnReevaluation,
				isValidateActor: this.isValidateActor,
				displayType: this.displayType,
				answers: answers,
				index: index
			};

			return parameters;
		},
		async deleteAnswer(index) {
			const input = {
				idInvite: this.idInvite,
				idRequirement: this.idRequirement,
				responseIndex: index
			};
			let attaches = [];
			try {
				attaches = await this.getRequirementAttaches(input);
			} catch (e) {
				attaches = [];
			}
			if (Array.isArray(attaches)) {
				attaches.forEach((file) => {
					if (file && file.idDocument && !this.deletedFilesId.includes(file.idDocument)) {
						this.deletedFilesId.push(file.idDocument);
					}
				});
			}

			this.questionsData.forEach((data) => {
				let newAnswers = [];
				data.answers.forEach((answer) => {
					if (answer.responseIndex === index) {
						this.$parent.$refs.ResponseRequirementModal.clearLocalFiles(answer.responseIndex);
					} else if (answer.responseIndex > index) {
						answer.responseIndex--;
						newAnswers.push(answer);
					} else {
						newAnswers.push(answer);
					}
				});
				data.answers = newAnswers;
			});
		},
		async handleDownloadFiles(index) {
			const input = {
				idInvite: this.idInvite,
				idRequirement: this.idRequirement,
				responseIndex: index
			};

			try {
				const attaches = await this.getRequirementAttaches(input);

				if (!Array.isArray(attaches) || attaches.length === 0) {
					this.$functions.displayWarning(this, this.$t("messages.noFilesToDownload"));
					return;
				}
				const idDocumentList = attaches.map((attach) => attach.idDocument).filter((id) => id !== null);
				await this.downloadRequirementResponseIndexDocument({ idDocumentList });
			} catch (error) {
				console.error("Erro ao baixar arquivos:", error);
			}
		},
		viewAnswer: async function (index) {
			const visualizationModal = true;
			const answers = this.questionsData.flatMap((data) => data.answers).filter((a) => a.responseIndex == index);
			const contextRequirement = this.createContextRequirementObject(answers, index, visualizationModal);

			await this.$parent.$refs.ResponseRequirementModal.setContextRequirement(contextRequirement);
			this.$bvModal.show("responseRequirementModal");
		},
		shouldDisplayDeleteOrEditAction(index) {
			if (this.requirement.blockTableAnswerDeleting) {
				const { canEditAnswer, isInMemory } = this.questionsData
					.flatMap((q) => q.answers)
					.find((a) => a.responseIndex === index);

				if (this.supplierHasCodeERP && !canEditAnswer && !isInMemory) {
					return false;
				}
			}

			const hasValidationForm = this.questionsData.some(({ formType }) => formType === this.$FormType.ValidationForm);
			const isClientValidation = this.modalType === this.$requirementResponseModalType.clientValidation;
			const isRequirementResponse = this.modalType === this.$requirementResponseModalType.requirementResponse;

			return (hasValidationForm && isClientValidation) || isRequirementResponse;
		},
		getAnswerDescriptionByType(question, answer) {
			if (typeof answer === "string" && answer.startsWith("[")) {
				try {
					answer = JSON.parse(answer);
				} catch (e) {
					console.error("Erro ao parsear resposta:", e);
					answer = [];
				}
			}

			switch (question.responseType) {
				case this.$ResponseType.Dropdown:
					answer = parseInt(answer, 10);
					return (
						question.dropdownAlternatives
							.filter((alt) =>
								Array.isArray(answer) ? answer.includes(alt.idAlternative) : answer === alt.idAlternative
							)
							.map((alt) => alt.description)
							.join(", ") || null
					);

				case this.$ResponseType.StandardList:
					answer = parseInt(answer, 10);
					return (
						question.standardListAlternatives
							.filter((alt) =>
								Array.isArray(answer) ? answer.includes(alt.idAlternative) : answer === alt.idAlternative
							)
							.map((alt) => alt.description)
							.join(", ") || null
					);

				case this.$ResponseType.MultipleSelection:
					return (
						question.checkAlternatives
							.filter((alt) =>
								Array.isArray(answer) ? answer.includes(alt.idAlternative) : answer === alt.idAlternative
							)
							.map((alt) => alt.description)
							.join(", ") || null
					);

				case this.$ResponseType.UniqueSelection:
					answer = parseInt(answer, 10);
					return (
						question.radioAlternatives
							.filter((alt) =>
								Array.isArray(answer) ? answer.includes(alt.idAlternative) : answer === alt.idAlternative
							)
							.map((alt) => alt.description)
							.join(", ") || null
					);

				default:
					return answer ?? null;
			}
		},
		async saveAnswers() {
			try {
				const mappedAnswers = this.mapQuestionAnswers();
				const input = this.buildSaveInput(mappedAnswers);
				const hasNewFile = this.checkForNewFiles(input.questionAnswers);
				const attachesWithIndex = this.getUniqueAttachesWithResponseIndex(input.questionAnswers);

				input.attach = attachesWithIndex;

				if (hasNewFile) {
					try {
						await this.uploadFileRequirementResponse(input);
					} catch (uploadError) {
						this.handleError(uploadError);
						return false;
					}
				}

				await this.createOrUpdateRequirementResponse(input);

				this.handleSuccess();
				return true;
			} catch (error) {
				this.handleError(error);
				return false;
			}
		},
		buildSaveInput(mappedAnswers) {
			return {
				idInvite: this.idInvite,
				idRequirement: this.idRequirement,
				...this.requirementResponseData,
				validityDate: this.$functions.formatDateToBack(this.requirementResponseData.validityDate),
				questionAnswers: mappedAnswers,
				status: this.getRequirementStatus(),
				deletedFilesId: this.deletedFilesId || [],
				attach: [],
				userConfirm: this.userConfirm || false,
				scoreValue: this.requirementResponseData.scoreValue || 0
			};
		},
		getRequirementStatus() {
			const mapModalTypeToFormType = {
				[this.$requirementResponseModalType.requirementResponse]: this.$FormType.FillerForm,
				[this.$requirementResponseModalType.clientValidation]: this.$FormType.ValidationForm,
				[this.$requirementResponseModalType.reprocess]: this.$FormType.ValidationForm
			};

			const hasSomePartialAnswer = () => {
				return this.questionsData
					.filter(({ formType }) => mapModalTypeToFormType[this.modalType] === formType)
					.some(({ answers }) =>
						answers.some(({ requirementStatus, ready }) => {
							const isPartial =
								requirementStatus === this.$RequirementStatus.PartialAnswer ||
								ready == this.$ResponseIndexReady.NotReady;

							const isValidationModal =
								this.modalType === this.$requirementResponseModalType.clientValidation ||
								this.modalType === this.$requirementResponseModalType.reprocess;

							return isValidationModal ? isPartial || ready === this.$ResponseIndexReady.FilledFormReady : isPartial;
						})
					);
			};

			if (hasSomePartialAnswer()) return this.$RequirementStatus.PartialAnswer;

			return this.modalType === this.$requirementResponseModalType.clientValidation
				? this.$RequirementStatus.Done
				: this.$RequirementStatus.InProgress;
		},
		checkForNewFiles(questionAnswers) {
			return questionAnswers.some(
				({ attaches }) => Array.isArray(attaches) && attaches.some((attach) => !attach.idInvite)
			);
		},
		getUniqueAttachesWithResponseIndex(questionAnswers) {
			const seenFiles = new Set();

			return questionAnswers.flatMap((q) => {
				if (!Array.isArray(q.attaches)) return [];

				return q.attaches
					.filter((file) => {
						const uniqueKey = `${q.responseIndex}_${file.name}`;
						if (seenFiles.has(uniqueKey)) return false;

						seenFiles.add(uniqueKey);
						return true;
					})
					.map((file) => ({
						file,
						responseIndex: q.responseIndex
					}));
			});
		},
		handleSuccess() {
			this.$functions.displaySuccess(this, this.$t("messages.updatedSuccessfully"));
		},

		handleError(error) {
			this.$functions.displayError(this, this.$t("modals.responseRequirement.saveRequirementResponseError"));
			console.error(error);
		},
		handleNewAnswer(data) {
			const { requirementQuestionData: answers } = data;

			if (!answers?.length) return;

			this.fileName = data.fileName;
			this.deletedFilesId = data.deletedFilesId;
			this.addedFile = data.addedFile;

			const lineResponseIsReady = (data) => {
				if (
					data.hasOwnProperty("requirementStatus") &&
					data.requirementStatus !== this.$RequirementStatus.PartialAnswer
				) {
					if (this.modalType === this.$requirementResponseModalType.requirementResponse) {
						return this.$ResponseIndexReady.FilledFormReady;
					} else if (
						this.modalType === this.$requirementResponseModalType.clientValidation ||
						this.modalType === this.$requirementResponseModalType.reprocess
					) {
						return this.$ResponseIndexReady.VallidFormReady;
					}
				}

				return this.$ResponseIndexReady.NotReady;
			};

			answers.forEach((answer) => {
				const questionIndex = this.questionsData.findIndex((question) => question.idQuestion == answer.idQuestion);
				const questionToEdit = this.questionsData[questionIndex]?.answers.find(
					({ responseIndex }) => responseIndex === answer.responseIndex
				);

				if (questionToEdit) {
					const changed =
						(questionToEdit.answer ?? "") !== (answer.answer ?? "") ||
						(questionToEdit.description ?? "") !== (answer.description?.description ?? "") ||
						(questionToEdit.justification ?? "") !== (answer.justification ?? "") ||
						(questionToEdit.requirementStatus ?? "") !== (answer.requirementStatus ?? "");

					Object.assign(questionToEdit, {
						answer: answer.answer,
						description: answer.description?.description,
						justification: answer.justification,
						requirementStatus: answer.requirementStatus,
						updated: changed ? true : questionToEdit.updated || false,
						attaches: Array.isArray(data.attach) ? [...data.attach] : [],
						ready: lineResponseIsReady(answer)
					});
				} else {
					const mappedAnswer = {
						idQuestion: answer.idQuestion,
						responseType: answer.responseType,
						answer: answer.answer,
						description: answer.description?.description,
						justification: answer.justification,
						responseIndex: answer.responseIndex,
						requirementStatus: answer.requirementStatus,
						isInMemory: true,
						updated: true,
						attaches: Array.isArray(data.attach) ? [...data.attach] : [],
						ready: lineResponseIsReady(answer)
					};
					this.questionsData[questionIndex]?.answers.push(mappedAnswer);
				}
			});
		},
		mapQuestionAnswers() {
			let mappedAnswers = [];

			const answers = this.questionsData.flatMap((a) => a.answers);
			answers.forEach((data) => {
				let answer = data.answer;
				if (typeof answer == "string") {
					answer = answer.trim() ? answer : null;
				} else if (answer != null) {
					answer = JSON.stringify(answer);
				}

				mappedAnswers.push({
					idAnswer: data.idAnswer,
					idQuestion: data.idQuestion,
					answer: answer,
					justification: data.justification,
					responseType: data.responseType,
					responseIndex: data.responseIndex,
					IsNewAnswer: data.isInMemory,
					attaches: data.attaches,
					ready: data.ready
				});
			});

			return mappedAnswers;
		},
		closeModal() {
			if (this.shouldShowConfirmModal && this.hasUpdatedAnswers()) {
				this.excluirModal(this.modalPartialAnswerConfirm)
					.OK(() => {
						this.clearModalData();
					})
					.Not(() => {
						this.$bvModal.show("dataTableComponent");
					});
			} else {
				this.clearModalData();
			}
		},
		clearModalData() {
			Object.assign(this.requirementResponseData, {
				issueDate: null,
				validityDate: null,
				userConfirm: null,
				observation: null
			});

			this.questionsData = [];
			this.$parent.$refs.ResponseRequirementModal.clearLocalFiles();
			this.shouldShowConfirmModal = true;
		},
		async okEvent() {
			let successOnCreate = true;
			if (this.isClientValidationOrReprocess()) {
				if (this.hasUpdatedAnswers()) {
					successOnCreate = await this.saveAnswers();
				}
				await this.approveRequirement();
			} else {
				successOnCreate = await this.saveAnswers();
			}

			if (successOnCreate) {
				this.shouldShowConfirmModal = false;
				await this.$parent.$refs.ResponseRequirementModal.clearLocalFiles();
				this.$bvModal.hide("dataTableComponent");
				this.$emit("closeModal");
			}
		},
		savePartialAnswers() {
			this.saveAnswers().then(() => {
				this.shouldShowConfirmModal = false;
				this.$bvModal.hide("dataTableComponent");
				this.$emit("closeModal");
			});
		},
		async cancelEvent() {
			if (this.isClientValidationOrReprocess()) {
				if (this.requirement.requirementType) {
					this.excluirModal(this.modalCancelConfirmConfigs).OK(async () => {
						let cancelInviteObj = {
							IdInvite: this.idInvite,
							currentIdStep: this.idStep,
							nextStepMessage: this.messageAction
						};

						if (this.hasUpdatedAnswers()) {
							await this.saveAnswers();
						}

						this.refuseRequirement(false).then(() => {
							this.$emit("closeModal");
							this.cancelInvite(cancelInviteObj).then(
								() => {
									this.$functions.displaySuccess(this, this.$t("messages.inviteCanceledSuccessfully"));
									this.$router.push({
										name: "enterpriseList",
										params: {}
									});
								},
								(error) => {
									this.$functions.displayError(
										this,
										this.$t("messages.inviteCancelationFail") + "\n" + error.response.data.error.message
									);
								}
							);
						});
					});
				} else {
					if (this.hasUpdatedAnswers()) {
						this.shouldShowConfirmModal = false;
						await this.saveAnswers();
					}
					this.refuseRequirement(true).then(() => {
						this.$bvModal.hide("dataTableComponent");
						this.$emit("closeModal");
					});
				}
			} else {
				this.$bvModal.hide("dataTableComponent");
				this.$emit("closeModal");
			}
		},
		reevaluateEvent: function () {
			if (this.modalType !== this.$requirementResponseModalType.clientValidation) return;

			if (!this.requirementResponseData.observation || !this.requirementResponseData.observation.trim()) {
				this.$functions.displayWarning(this, this.$t("modals.responseRequirement.reevaluationMandatoryObservation"));
				return;
			}
			this.reevaluateRequirement().then(() => {
				this.$bvModal.hide("dataTableComponent");
				this.$emit("closeModal");
			});
		},
		approveRequirement: function () {
			return new Promise((resolve, reject) => {
				const validatorQuestions = this.mappedQuestionsWithConditions
					.filter(({ formType }) => formType === this.$FormType.ValidationForm)
					.map((question) => {
						const answerData = this.requirementQuestionData.find((q) => q.idQuestion === question.idQuestion);
						const answerObject = this.questionsData
							.find((data) => data.idQuestion === question.idQuestion)
							?.answers.find(
								(ans) => ans.answer === answerData?.answer && ans.responseIndex === answerData?.responseIndex
							);

						return {
							idQuestion: question.idQuestion,
							responseType: question.responseType,
							answer: answerData?.answer || null,
							justification: answerData?.justification || "",
							responseIndex: answerObject?.responseIndex
						};
					});

				let input = {
					idInvite: this.idInvite,
					idRequirement: this.idRequirement,
					status: this.$RequirementStatus.Accepted,
					observation: this.requirementResponseData.observation,
					scoreValue: this.requirementResponseData.scoreValue,
					validityDate: this.$functions.formatDateToBack(this.requirementResponseData.validityDate),
					validatorQuestions: validatorQuestions
				};

				let allOk = this.$refs.tableRequirementResponseCRUD.validateAllFields();
				if (allOk) {
					this.updateRequirementResponseWorkflow(input).then(
						() => {
							this.$functions.displaySuccess(
								this,
								this.$t("modals.responseRequirement.requirementApprovedSuccessfully")
							);
							this.requirementResponseData.observation = null;
							this.requirementResponseData.validityDate = null;
							resolve();
						},
						(error) => {
							this.$functions.displayError(
								this,
								this.$t("modals.responseRequirement.approveRequirementError") + "\n" + error
							);
							reject();
						}
					);
				} else {
					this.$functions.displayError(this, this.$t("modals.responseRequirement.verifyRequirements"));
					reject();
				}
			});
		},
		refuseRequirement: function (shouldShowAlert) {
			return new Promise((resolve) => {
				let input = {
					idInvite: this.idInvite,
					idRequirement: this.idRequirement,
					status: this.$RequirementStatus.Rejected,
					observation: this.requirementResponseData.observation,
					validityDate: this.$functions.formatDateToBack(this.requirementResponseData.validityDate)
				};

				this.updateRequirementResponseWorkflow(input).then(
					() => {
						if (shouldShowAlert) {
							this.$functions.displaySuccess(
								this,
								this.$t("modals.responseRequirement.requirementRejectedSuccessfully")
							);
						}
						this.requirementResponseData.observation = null;
						this.requirementResponseData.validityDate = null;
						resolve();
					},
					(error) => {
						this.$functions.displayError(
							this,
							this.$t("modals.responseRequirement.requirementRejectError") + "\n" + error
						);
					}
				);
			});
		},
		reevaluateRequirement: function () {
			return new Promise((resolve) => {
				let input = {
					idInvite: this.idInvite,
					idRequirement: this.idRequirement,
					status: this.$RequirementStatus.InReevaluation,
					observation: this.requirementResponseData.observation,
					validityDate: this.$functions.formatDateToBack(this.requirementResponseData.validityDate)
				};
				this.updateRequirementResponseWorkflow(input).then(
					() => {
						this.$functions.displaySuccess(
							this,
							this.$t("modals.responseRequirement.requirementToReevaluationSuccessfully")
						);
						this.requirementResponseData.observation = null;
						this.requirementResponseData.validityDate = null;
						resolve();
					},
					(error) => {
						this.$functions.displayError(
							this,
							this.$t("modals.responseRequirement.requirementoReevaluationError") + "\n" + error
						);
					}
				);
			});
		},
		getAnswerDescription(question, index) {
			const answer = question.answers && question.answers[index]?.answer;
			return this.getAnswerDescriptionByType(question, answer);
		},
		isTruncated(refName) {
			setTimeout(() => {
				const element = this.$refs[refName] ? this.$refs[refName][0] : null;
				if (element) {
					const isTextTruncated = element.scrollWidth > element.clientWidth;
					if (isTextTruncated) {
						element.setAttribute("title", element.innerText);
					} else {
						element.removeAttribute("title");
					}
					return isTextTruncated;
				}
				return false;
			}, 10);
		},
		hasUpdatedAnswers() {
			return this.questionsData
				.flatMap((question) => question.answers)
				.some((answer) => answer.updated && answer.isInMemory);
		},
		isClientValidationOrReprocess() {
			return (
				this.modalType == this.$requirementResponseModalType.clientValidation ||
				this.modalType == this.$requirementResponseModalType.reprocess
			);
		},
		hasAttachmentsForIndex(index) {
			return this.questionsData.some((q) => q.answers?.some((a) => a.responseIndex === index && a.hasAnyAttach));
		}
	},
	mounted() {
		this.$parent.$on("saveAnswer", (answers) => {
			this.handleNewAnswer(answers);
		});
	}
};
</script>

<style scoped>
.table-responsive {
	max-width: 100%;
	overflow-x: auto;
}

@media (min-width: 1106px) {
	.table-responsive {
		overflow-x: scroll;
	}
}

table {
	border-collapse: collapse;
	width: 100%;
}

th,
td {
	border: 1px solid #ddd;
	padding: 8px;
	text-align: left;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	min-width: 9rem;
	max-width: 12rem;
}
th:first-child,
td:first-child {
	width: 9rem;
	white-space: nowrap;
}

th {
	background-color: #f4f4f4;
}

.edit-button:hover,
.download-button:hover,
.view-button:hover {
	color: gray;
}
.remove-button:hover {
	color: #f73939;
}
.right-align {
	display: flex;
	justify-content: flex-end;
	width: 100%;
}
.display-properties {
	font-size: 12px;
}
.basicInformations {
	width: 100%;
}
.basicInformations label {
	font-weight: bold;
	font-size: 12px;
}
.details {
	max-height: 300px;
	overflow: auto;
	padding: 0px 30px 0px 30px;
}
.textModal {
	display: flex;
}
.formatted-text-display {
	width: 75%;
	background-color: transparent;
	min-height: 40px;
	overflow: visible;
	white-space: pre-wrap;
	word-wrap: break-word;
}

.display-answers-modal {
	width: 100%;
	background-color: transparent;
	min-height: 1rem;
	white-space: pre-wrap;
	word-wrap: break-word;
	word-break: break-all;
	overflow-wrap: break-word;
}
</style>

<style>
#dataTableComponent___BV_modal_footer_ .btn-primary {
	background-color: #19b600;
	border-color: #19b600;
}
#dataTableComponent___BV_modal_footer_ .btn-secondary {
	background-color: #ff0000;
	border-color: #ff0000;
}

.hideButtons #dataTableComponent___BV_modal_footer_ .btn-primary {
	display: none;
}
.hideButtons #dataTableComponent___BV_modal_footer_ .btn-secondary {
	display: none;
}

.modalPadding {
	padding: 0px 30px 0px 30px;
}

.badge-lg {
	padding: 0.5em 1em;
	text-transform: uppercase;
}
</style>
